// extracted by mini-css-extract-plugin
export default {"shimmer":"_b9831ef8","shimmerLoadingBackground":"_2a2c5290"};